/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerDownloadBlankTemplateQueryResponse } from "../../models/checklistsController/TemplatesControllerDownloadBlankTemplate";

function getTemplatesControllerDownloadBlankTemplateUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-templates/blank-template` as const }  
  return res
}

/**
 * @description Generates an empty 5-tab Excel file with headers only, suitable as a starting point for building templates via import.
 * @summary Download blank checklist template Excel file
 * {@link /api/v1/checklist-templates/blank-template}
 */
export async function templatesControllerDownloadBlankTemplate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplatesControllerDownloadBlankTemplateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getTemplatesControllerDownloadBlankTemplateUrl().url.toString(), ... requestConfig })  
  return res.data
}